import { jsx as e } from "react/jsx-runtime";
//#region src/IconAccessibilityArcomClosedCaptioning.tsx
function t(t) {
	return /* @__PURE__ */ e("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		...t,
		children: /* @__PURE__ */ e("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "m17.484 2.717 1.47 1.831 1.369-1.707V1.013L18.873 1zm-3.219 4.884q-1.148-1.056-2.771-1.057-1.825 0-2.988 1.285l-.958-.908c1.046-1.105 2.36-1.663 3.946-1.663q2.174.002 3.731 1.437c1.032.95 1.55 2.101 1.55 3.439q-.001 2.194-1.798 3.64l-.96-.884c.927-.735 1.39-1.65 1.39-2.756 0-.983-.377-1.826-1.142-2.533m-4.588 5.747L8.09 11.645 4 16.002v3.45zm4.51 4.965q-1.602 1.166-1.925 1.688-1.75 2.886-3.934 2.999-1.69-.03-2.745-1.017c.53-.503.838-.805.934-.901q.82.669 1.955.553.874-.088 1.983-1.361l.884-1.04.748-.879c.292-.27.864-.684 1.708-1.247s1.521-1.083 2.025-1.568q2.566-2.412 2.566-5.283-.002-2.701-1.868-4.588-1.865-1.885-4.545-1.885-2.046 0-3.69 1.13-1.65 1.131-2.379 2.932L4.71 7.322a7.9 7.9 0 0 1 2.87-3.55 7.6 7.6 0 0 1 4.393-1.353q3.265-.001 5.508 2.285c1.5 1.521 2.207 3.366 2.126 5.516q-.115 3.934-3.527 6.754c-.64.446-1.272.89-1.893 1.34",
			clipRule: "evenodd"
		})
	});
}
t.displayName = "IconAccessibilityArcomClosedCaptioning";
//#endregion
export { t as default };

//# sourceMappingURL=IconAccessibilityArcomClosedCaptioning.js.map